{
  "assistant.page.title": "Yapay zekâ erişimi",
  "assistant.page.lede": "Yapay zekâ istemcilerini OAuth ve MCP ile bağla, yaptıkları değişiklikleri incele ve devamlılığı kendi denetiminde tut.",
  "assistant.page.privacy": "Yalnız MCP · sağlayıcı anahtarı yok",
  "assistant.page.open": "Yapay zekâ erişimini aç",
  "assistant.page.boundary.title": "İstemcin bağlanır; Exognitos model sağlayıcısı çağırmaz",
  "assistant.page.boundary.description": "Exognitos izin kapsamlı araçları MCP üzerinden sunar. Model sağlayıcısı API anahtarı saklamaz ve hesap bağlamını bir model servisine göndermez. Her çağrının sahibi ve yetkisi, bağlı istemcinin doğrulanmış kimlik bilgisinden yeniden türetilir.",
  "assistant.page.review.title": "İnceleme ve hesap verebilirlik",
  "assistant.page.review.description": "Önerilen hafızaları kabul et veya reddet, işlem makbuzlarını ve kaynak bilgisini incele, profil bilgileri güvenilir bağlama dönüşmeden önce onları gözden geçir.",
  "assistant.page.profile.action": "Profil bilgilerini incele"
}
